import { Component } from '@angular/core';

@Component({
  selector: 'empathy-carousel-form',
  templateUrl: 'carousel-form.component.html',
  styleUrls: ['./carousel-form.component.scss', './_carousel-form-theme.component.scss']
})
export class CarouselFormComponent {}
